module.exports = __webpack_public_path__ + "img/jm.755951cf.svg";